import { setRangeMin } from './helpers';

export const setLivingAreaMin = setRangeMin('living_area');
